import img3 from "../assets/flood_final1.jpg";
import img1 from "../assets/flood_final2.jpg";
// import img2 from '../assets/flood_final3.png'

export default {
  items: [
    {
      id: 1,
      // caption:"Slide 1",
      img: img1,
      // description:"Add The 1st slide"
    },
    {
      id: 2,
      img: img3,
      // caption:"slide 2",
      // description:"Add The 2nd slide"
    },
    // {
    //     id:3,
    //     img:img3,
    //     // caption:"slide 3",
    //     // description:"Add The 3rd slide"
    // },
  ],
};
